import React from "react";

type Props = {
    angle: number;
    value: number;
    selected: boolean;
    onClick: () => void;
};

function formatString(value: number): string {
    return value.toString(10).padStart(2, "0");
}

export class TimePickerTrackItem extends React.Component<Props> {
    public render(): React.ReactNode {
        const { angle, value, selected, onClick } = this.props;

        return (
            <div
                className={"calendar-time-picker-track-item" + (selected ? " selected" : "")}
                style={{
                    transform: `rotate3d(1, 0, 0, ${angle}deg) translateZ(4rem)`,
                }}
                onClick={onClick}
            >
                {formatString(value)}
            </div>
        );
    }
}
